import React, { useState } from 'react'
import { Col, Dropdown, Modal, ModalBody, ModalTitle, Row } from 'react-bootstrap'
import { ReactComponent as IconApprove } from '../../assets/images/icons/icon-approve-modal.svg'
import { ReactComponent as IconDecline } from '../../assets/images/icons/icon-decline-modal.svg'
import { ReactComponent as IconClose } from '../../assets/images/icons/icon-modal-close.svg'
import { Controller, useForm } from 'react-hook-form'

import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'

const validationSchema = yup.object({
    note: yup
        .string()
        .trim()
        .required('Please enter note')
        .min(15, 'Please enter minimun 15 character')
})

const ApproveDeclinePopup = ({
    ShowMaterialStatusPopup,
    setShowMaterialStatusPopup,
    title,
    handlePermission,
    text,
    noteText,
    setnoteText,
    reason,
    setReason,
    ReasonList,
    ShowReportModalPopup,
    setShowReportModalPopup
}) => {
    const{register, handleSubmit,formState:{errors},watch,control} = useForm({ resolver: yupResolver(validationSchema)})

    const handleReport=(data)=>{
        const {note,reason:{reasons:reason}}= data
        handlePermission({note,reason},()=>{
            setShowReportModalPopup(false)
        })
    }
    
    return (
        <>
            <Modal
                centered
                style={{ backdropFilter: 'blur(2px)' }}
                className="modalbox deletemodal confirm-modal"
                show={ShowMaterialStatusPopup}
                onHide={() => setShowMaterialStatusPopup(false)}
            >
                <Modal.Header>
                    <ModalTitle>{title}</ModalTitle>
                </Modal.Header>
                <ModalBody>
                    <div className="mb-4">
                        {text == 'Decline' || text == 'Decline Product' ? (
                            <IconDecline />
                        ) : text == 'Approve' || text == 'Approve Product' ? (
                            <IconApprove />
                        ) : (
                            ''
                        )}
                    </div>
                    <h2>{title}</h2>
                    <div className="modal-btn-group">
                        <button
                            className="border-red-btn  modal-btn"
                            onClick={() => {
                                setShowMaterialStatusPopup(false)
                            }}
                        >
                            Cancel
                        </button>
                        <button
                            type="button"
                            className="solid-red-btn modal-btn"
                            onClick={
                                text.includes('Decline Product') === true
                                    ? () => setShowReportModalPopup(true)
                                    : () => handlePermission()
                            }
                        >
                            {text.includes('Decline Product') === true
                                ? 'Decline'
                                : text.includes('Approve Product') === true
                                ? 'Approve'
                                : text}
                        </button>
                    </div>
                </ModalBody>
            </Modal>

            {/* Report Modal */}
            <Modal
                centered
                className="modalbox confirm-modal filter-modal  repor-modal"
                show={ShowReportModalPopup}
                onHide={() => setShowReportModalPopup(false)}
            >
                <ModalBody>
                    <div className="head">
                        <h2>Product Report</h2>
                        <div
                            className="close"
                            onClick={() => {
                                setShowReportModalPopup(false)
                            }}
                        >
                            <IconClose />
                        </div>
                    </div>
                    <form onSubmit={handleSubmit(handleReport)}>
                        <Row>
                        <Col lg="12" md="6" sm="12">
                        <div className="form-group">
                                <label>Reason</label>
                                <Controller
                                    control={control}
                                    name="reason"
                                    render={({
                                        field: { onChange, onBlur, value, ref }
                                    }) => (
                                        <Dropdown
                                            flip="no"
                                            onSelect={(e) => {
                                                console.log(e)
                                                setReason(JSON.parse(e))
                                                onChange(JSON.parse(e))
                                            }}
                                            name="reason"
                                            drop="down-centered"
                                            {...register('reason')}
                                        >
                                            <Dropdown.Toggle
                                                variant="success"
                                                id="dropdown-basic"
                                            >
                                                {reason?.reasons || "Select Reason"}
                                            </Dropdown.Toggle>
                                           
                                            <Dropdown.Menu>
                                                {ReasonList?.data?.map(
                                                    (mCat) => {
                                                        return (
                                                            <Dropdown.Item
                                                                key={mCat?.reasons}
                                                                eventKey={JSON.stringify(
                                                                    mCat
                                                                )}
                                                            >
                                                                {mCat?.reasons}
                                                            </Dropdown.Item>
                                                        )
                                                    }
                                                )}
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    )}
                                ></Controller>
                                {errors?.reason && (
                                    <span
                                        className="error-message"
                                        style={{ color: 'red' }}
                                    >
                                        {' '}
                                        {errors?.reason?.message}
                                    </span>
                                )}
                            </div>
                            </Col>
                            <Col lg="12" md="6" sm="12">
                                <div className="form-group">
                                    <label>Note</label>
                               <textarea
                                        name="note"
                                        id=""
                                        cols="30"
                                        rows="8"
                                        placeholder="Write a message"
                                         {...register('note',{onChange:(e)=>setnoteText(e.target.value)})}
                                    ></textarea>
                                    {errors.note && <span style={{color:"red"}}>{errors.note.message}</span>}
                                </div>
                            </Col>
                            <Col lg="12">
                                <div className="modal-btn-group">
                                    <button
                                        disabled={noteText == '' ? true : false}
                                        // type="button"
                                        className="solid-red-btn modal-btn"
                                        //   onClick={handlePermission}
                                    >
                                        Report
                                    </button>
                                </div>
                            </Col>
                        </Row>
                    </form>
                </ModalBody>
            </Modal>
        </>
    )
}

export default ApproveDeclinePopup
